module.exports = __webpack_public_path__ + "img/2.27fe81e8.jpg";